/* global var */

var initAll3D = false;
var timeCheckBuild3D;
var seqScr = [];
var objects3D = [];
var ratio = window.innerWidth / window.innerHeight;

var umpApp = {

    init: function () {
        console.log("init Ump App");
        this.eventClick = this.getTypeDevice();

        this.initOnReady();
        this.initOnResize();

    },
    initOnReady: function () {
        $(document).ready(function () {
            umpApp.onReady();
        });
    },
    initOnResize: function () {
        $(window).resize(function () {
            umpApp.onResize();
        }, false);
    },
    getTypeDevice: function () {
        // init media tape
        return (
            !!(typeof window !== 'undefined' && ('ontouchstart' in window ||
                (window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch))) ||
            !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints))
        );

    },
};